import { setSubscriptionPrices } from "./subscriptionPricesData";
import {
  setBankCards,
  setCompaniesList,
  setCompanyData,
  setGlobalLoading,
  setRouterUserRequestInProgress,
  setSalsa,
  setUserMetaData,
  setUserRewardPoints,
  setWorkerKycOnboardingInProgress,
  updateUserMetaDataLastActiveRole,
} from "./userMetaData";

const actions = {
  userMetaData: {
    setUserMetaData,
    setCompanyData,
    setCompaniesList,
    setGlobalLoading,
    updateUserMetaDataLastActiveRole,
    setWorkerKycOnboardingInProgress,
    setRouterUserRequestInProgress,
    setUserRewardPoints,
    setBankCards,
  },
  salsaData: {
    setSalsa,
  },
  subscriptionPricesData: {
    setSubscriptionPrices,
  },
};

export default actions;
